/*--------------------------------------------------------------
## jQuery
--------------------------------------------------------------*/
var jQuery = require('jquery');

var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin(jQuery);

var matchHeight = require('jquery-match-height');


jQuery.noConflict();


// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}


/*--------------------------------------------------------------
## AutoHeight
--------------------------------------------------------------*/

jQuery(document).imagesLoaded(function () {
    "use strict";

    jQuery('.auto-height').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

});


/*--------------------------------------------------------------
## SmoothScroll
--------------------------------------------------------------*/

jQuery(function() {
    "use strict";
    jQuery('.smoothscroll').click(function() {
            var scrollID = jQuery(this).data('scrollto');
        if(scrollID){
            var target = jQuery(scrollID);
            if (target.length) {
                jQuery('html,body').animate({
                    scrollTop: (target.offset().top)
                }, 600);
                return false;
            }
        }

    });
});

/*--------------------------------------------------------------
 ## Helper isVisible
 --------------------------------------------------------------*/

(function(jQuery) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    jQuery.fn.visible = function(partial) {

        var jQueryt            = jQuery(this),
            jQueryw            = jQuery(window),
            viewTop       = jQueryw.scrollTop(),
            viewBottom    = viewTop + jQueryw.height(),
            _top          = jQueryt.offset().top,

            _bottom       = _top + jQueryt.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

})(jQuery);




/*
 * HeadsUp 1.5.6
 * @author Kyle Foster (@hkfoster)
 * @license MIT
 */
(function( window, document, undefined ) {

    'use strict';

    // Extend function
    function extend( a, b ) {
        for( var key in b ) {
            if( b.hasOwnProperty( key ) ) {
                a[ key ] = b[ key ];
            }
        }
        return a;
    }

    // Throttle function (http://bit.ly/1eJxOqL)
    function throttle( fn, threshhold, scope ) {
        threshhold || ( threshhold = 250 );
        var previous, deferTimer;
        return function () {
            var context = scope || this,
                current = Date.now(),
                args    = arguments;
            if ( previous && current < previous + threshhold ) {
                clearTimeout( deferTimer );
                deferTimer = setTimeout( function () {
                    previous   = current;
                    fn.apply( context, args );
                }, threshhold );
            } else {
                previous = current;
                fn.apply( context, args );
            }
        };
    }

    // Class management functions
    function classReg( className ) {
        return new RegExp( '(^|\\s+)' + className + '(\\s+|$)' );
    }

    function hasClass( el, cl ) {
        return classReg( cl ).test( el.className );
    }

    function addClass( el, cl ) {
        if ( !hasClass( el, cl ) ) {
            el.className = el.className + ' ' + cl;
        }
    }

    function removeClass( el, cl ) {
        el.className = el.className.replace( classReg( cl ), ' ' );
    }

    // Main function definition
    function headsUp( selector, options ) {
        this.selector = document.querySelector( selector );
        this.options  = extend( this.defaults, options );
        this.init();
    }

    // Overridable defaults
    headsUp.prototype = {
        defaults : {
            delay       : 1000,
            sensitivity : 50
        },

        // Init function
        init : function( selector ) {

            var self         = this,
                options      = self.options,
                selector     = self.selector,
                oldScrollY   = 0,
                winHeight;

            // Resize handler function
            function resizeHandler() {
                winHeight = window.innerHeight;
                return winHeight;
            }

            function changeHeader() {
                var newScrollY = window.pageYOffset,
                    docHeight  = document.body.scrollHeight,
                    pastDelay  = newScrollY > options.delay,
                    goingDown  = newScrollY > oldScrollY,
                    fastEnough = newScrollY < oldScrollY - options.sensitivity,
                    rockBottom = newScrollY < 0 || newScrollY + winHeight >= docHeight;

                if ( newScrollY > 300  ) {
                    addClass( selector, 'fixedheader--visible' );
                } else if ( !goingDown && newScrollY < 300 ) {
                    removeClass( selector, 'fixedheader--visible' );
                }
            }

            // Scroll handler function
            function scrollHandler() {

                // Scoped variables
                var newScrollY = window.pageYOffset,
                    docHeight  = document.body.scrollHeight,
                    pastDelay  = newScrollY > options.delay,
                    goingDown  = newScrollY > oldScrollY,
                    fastEnough = newScrollY < oldScrollY - options.sensitivity,
                    rockBottom = newScrollY < 0 || newScrollY + winHeight >= docHeight;

                // Where the magic happens
                if ( pastDelay && goingDown ) {
                    addClass( selector, 'heads-up' );
                } else if ( !goingDown && fastEnough && !rockBottom || !pastDelay ) {
                    removeClass( selector, 'heads-up' );
                }

                // Keep on keeping on
                oldScrollY = newScrollY;
            }

            // Attach listeners
            if ( selector ) {

                // Trigger initial resize
                resizeHandler();

                // Resize function listener
                window.addEventListener( 'resize', throttle( resizeHandler ), false );

                // Scroll function listener
                window.addEventListener( 'scroll', throttle( scrollHandler, 100 ), false );
                window.addEventListener( 'scroll', throttle( changeHeader, 100 ), false );
            }
        }
    };

    window.headsUp = headsUp;

})( window, document );

// Instantiate HeadsUp
new headsUp( '.fixedheader' );

/*--------------------------------------------------------------
 ## Fullscreen
 --------------------------------------------------------------*/

var initIsFullscreen = function() {
    var isFullscreen = jQuery('.section--fullscreen'),
        windowHeight = jQuery(window).outerHeight(),
        isFullscreenHeight = windowHeight;

    isFullscreen.each(function() {
        jQuery(this).css('height', isFullscreenHeight);
    });
};

jQuery(document).ready(function() {
    initIsFullscreen();

});


jQuery(window).resize(function() {
    initIsFullscreen();
});




// WEBPACK FOOTER //
// ./src/assets/js/scripts.js